import React from 'react';

const GDPRModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
      <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-auto my-8 sm:my-16">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">Zásady ochrany osobních údajů</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl font-bold"
          >
            ×
          </button>
        </div>
        
        <div className="prose max-w-none text-gray-900">
          <h3 className="text-lg font-semibold mb-3 text-gray-900">Zásady zpracování osobních údajů (GDPR)</h3>
          <p className="mb-4 text-gray-800"><strong>Verze: 1, účinná od 25. 7. 2025</strong></p>
          
          <p className="mb-4 text-gray-800">
            Tyto Zásady zpracování osobních údajů (dále jen „Zásady") popisují, jakým způsobem společnost Vyjednáme, s.r.o., IČO 21377596, se sídlem Příčná 1892/4, Nové Město (Praha 1), 110 00 Praha (dále jen „společnost"), zpracovává osobní údaje v souladu s platnými právními předpisy, včetně Nařízení Evropského parlamentu a Rady (EU) 2016/679 (dále jen „GDPR").
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">1. Úvod</h4>
          <p className="mb-4 text-gray-800">
            Společnost zpracovává osobní údaje v souladu s GDPR a dalšími právními předpisy na ochranu osobních údajů.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">2. Jaké osobní údaje zpracováváme a proč?</h4>
          <p className="mb-4 text-gray-800">Zpracováváme pouze nezbytné osobní údaje pro následující účely:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li>Uzavření a plnění smluvního vztahu</li>
            <li>Předjednání obchodní spolupráce</li>
            <li>Marketingová komunikace na základě oprávněného zájmu</li>
            <li>Plnění zákonných povinností</li>
            <li>Tvorba technických řešení</li>
          </ul>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">3. Právní základ zpracování osobních údajů</h4>
          <p className="mb-4 text-gray-800">Osobní údaje zpracováváme na základě:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li>Souhlasu subjektu údajů (čl. 6 odst. 1 písm. a) GDPR)</li>
            <li>Plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR)</li>
            <li>Oprávněného zájmu (čl. 6 odst. 1 písm. f) GDPR)</li>
            <li>Plnění právních povinností (čl. 6 odst. 1 písm. c) GDPR)</li>
          </ul>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">4. Oprávněný zájem a zásady kontaktování</h4>
          <p className="mb-4 text-gray-800">
            Společnost Vyjednáme, s.r.o. oslovuje pouze zákazníky, u nichž existuje právní základ pro zpracování osobních údajů, a to zejména:
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li>na základě uzavřené smlouvy nebo předjednávání obchodního vztahu,</li>
            <li>na základě oprávněného zájmu v souladu s článkem 6 odst. 1 písm. f) GDPR,</li>
            <li>v případech, kdy subjekt údajů udělil souhlas.</li>
          </ul>
          
          <p className="mb-4 text-gray-800">
            Souhlas se zpracováním osobních údajů může být udělen prostřednictvím opt-in formuláře dostupného na našem webu.
          </p>
          
          <p className="mb-4 text-gray-800">
            Veškeré kontakty jsou pravidelně kontrolovány, aby bylo zajištěno, že nebudou oslovovány osoby, které si to nepřejí.
          </p>
          
          <p className="mb-4 text-gray-800">
            V případě, že jakýkoli subjekt údajů nesouhlasí s kontaktováním, může svůj nesouhlas oznámit na e-mail info@vyjedname.cz, přičemž společnost zajistí okamžité vyřazení jeho kontaktních údajů z databáze.
          </p>
          
          <p className="mb-4 text-gray-800">
            V situacích, kdy dojde k omylem uskutečněnému kontaktování, například v důsledku chyby při zadávání čísla, se tento omyl neprodleně napraví vyřazením kontaktu z evidence. I přesto, že činíme maximum pro prevenci chyb, nemůžeme garantovat, že k takovýmto chybám nikdy nedojde. Obchodník je upozorněn na nutnost dodržování interních pravidel a je školen v prevenci takovýchto situací.
          </p>
          
          <p className="mb-4 text-gray-800">
            Společnost Vyjednáme, s.r.o. dodržuje platné právní předpisy, včetně zákona č. 127/2005 Sb., o elektronických komunikacích, a spolupracuje s dozorovými orgány při řešení případných podnětů.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">5. Kdo má přístup k osobním údajům?</h4>
          <p className="mb-4 text-gray-800">Osobní údaje mohou být předány:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li>Společnosti Vodafone Czech Republic a.s. jakožto smluvnímu partnerovi</li>
            <li>Externím zpracovatelům, kteří nám pomáhají se správou databází a marketingovými aktivitami</li>
            <li>Orgánům veřejné správy, pokud to vyžaduje zákon</li>
          </ul>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">6. Jak dlouho osobní údaje uchováváme?</h4>
          <p className="mb-4 text-gray-800">
            Osobní údaje uchováváme pouze po dobu nezbytnou k naplnění účelu jejich zpracování, pokud právní předpis nestanoví jinak. V případech, kdy to právní předpisy umožňují, mohou být údaje uchovávány po dobu neurčitou, přičemž je pravidelně přezkoumávána jejich nezbytnost.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">7. Jaká jsou vaše práva?</h4>
          <p className="mb-4 text-gray-800">Subjekt údajů má právo:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li>Požadovat přístup ke svým osobním údajům</li>
            <li>Požadovat opravu nebo výmaz údajů</li>
            <li>Vznést námitku proti zpracování</li>
            <li>Požadovat omezení zpracování</li>
            <li>Podat stížnost u Úřadu pro ochranu osobních údajů (<a href="https://www.uoou.cz" className="text-blue-600 hover:underline">www.uoou.cz</a>)</li>
          </ul>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">8. Jak chráníme osobní údaje?</h4>
          <p className="mb-4 text-gray-800">
            Přijímáme vhodná technická a organizační opatření k ochraně osobních údajů před neoprávněným přístupem, ztrátou nebo zneužitím.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">9. Delegování odpovědnosti za aktivní obchodní akvizice</h4>
          <p className="mb-4 text-gray-800">Pro účely aktivní obchodní akvizice je odpovědnost delegována na následující fyzické osoby:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li>David Formánek, IČO: 08234396, e-mail: david.formanek@vyjedname.cz</li>
            <li>Jakub Dufek, IČO: 07770090, e-mail: jakub.dufek@vyjedname.cz</li>
          </ul>
          
          <p className="mb-4 text-gray-800">
            Oba výše uvedení jsou oprávněni jednat jménem společnosti v oblasti aktivní obchodní akvizice. Odpovídají za veškerou komunikaci a správu kontaktů a zároveň jsou povinni dodržovat všechny příslušné právní předpisy, včetně GDPR a zákona o elektronických komunikacích. V případě dotazů či nesrovnalostí se mohou subjekty údajů obracet přímo na uvedené e-mailové adresy.
          </p>
          
          <p className="mb-4 text-gray-800">
            Tato delegace odpovědnosti byla provedena v souladu s interními pravidly společnosti a platnou legislativou.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">10. Kontakt</h4>
          <p className="mb-4 text-gray-800">
            Máte-li jakékoli dotazy ohledně zpracování osobních údajů, kontaktujte nás na e-mailu: info@vyjedname.cz.
          </p>
          
          <div className="mt-6 pt-4 border-t">
            <p className="text-sm text-gray-600">
              <strong>Kontaktní údaje:</strong><br />
              Vyjednáme, s.r.o.<br />
              Příčná 1892/4, Nové Město (Praha 1), 110 00 Praha<br />
              IČO: 21377596<br />
              E-mail: info@vyjedname.cz
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GDPRModal;
